import React, { useState, useEffect } from 'react';
import API from '../api';

const emptyForm = { name: '', durationMinutes: '', price: '' };

const ServicesPanel = () => {
    const [services, setServices] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [newService, setNewService] = useState(emptyForm);
    const [editingId, setEditingId] = useState(null);
    const [editValues, setEditValues] = useState(emptyForm);

    useEffect(() => {
        fetchServices();
    }, []);

    const fetchServices = async () => {
        try {
            const res = await API.get('/medical-services');
            setServices(res.data);
        } catch (err) {
            console.error("Greška pri učitavanju tretmana", err);
        }
    };

    const handleNewChange = (e) => {
        setNewService({ ...newService, [e.target.name]: e.target.value });
    };

    const handleCreate = async (e) => {
        e.preventDefault();
        try {
            await API.post('/medical-services', {
                name: newService.name,
                durationMinutes: parseInt(newService.durationMinutes, 10),
                price: newService.price === '' ? null : parseFloat(newService.price)
            });
            setNewService(emptyForm);
            setShowForm(false);
            fetchServices();
        } catch (err) {
            alert("Greška pri dodavanju tretmana!");
        }
    };

    const startEdit = (service) => {
        setEditingId(service.id);
        setEditValues({
            name: service.name,
            durationMinutes: service.durationMinutes,
            price: service.price ?? ''
        });
    };

    const cancelEdit = () => {
        setEditingId(null);
        setEditValues(emptyForm);
    };

    const handleEditChange = (e) => {
        setEditValues({ ...editValues, [e.target.name]: e.target.value });
    };

    const saveEdit = async (id) => {
        try {
            await API.put(`/medical-services/${id}`, {
                name: editValues.name,
                durationMinutes: parseInt(editValues.durationMinutes, 10),
                price: editValues.price === '' ? null : parseFloat(editValues.price)
            });
            cancelEdit();
            fetchServices();
        } catch (err) {
            alert("Greška pri izmeni tretmana!");
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Obrisati ovaj tip tretmana?")) return;
        try {
            await API.delete(`/medical-services/${id}`);
            fetchServices();
        } catch (err) {
            alert("Greška pri brisanju tretmana!");
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h2 style={styles.title}>Tipovi tretmana</h2>
                <button style={styles.addBtn} onClick={() => setShowForm(!showForm)}>
                    {showForm ? 'Zatvori' : '+ Novi tretman'}
                </button>
            </div>

            {showForm && (
                <form onSubmit={handleCreate} style={styles.form}>
                    <input name="name" placeholder="Naziv tretmana" value={newService.name} onChange={handleNewChange} required style={styles.input} />
                    <input name="durationMinutes" type="number" min="1" placeholder="Trajanje (min)" value={newService.durationMinutes} onChange={handleNewChange} required style={styles.input} />
                    <input name="price" type="number" min="0" step="0.01" placeholder="Cena (opciono)" value={newService.price} onChange={handleNewChange} style={styles.input} />
                    <button type="submit" style={styles.saveBtn}>Sačuvaj</button>
                </form>
            )}

            <div style={styles.listWrapper}>
                {services.length > 0 ? (
                    services.map(s => (
                        <div key={s.id} style={styles.row}>
                            {editingId === s.id ? (
                                <>
                                    <div style={styles.editFields}>
                                        <input name="name" value={editValues.name} onChange={handleEditChange} style={styles.editInput} />
                                        <input name="durationMinutes" type="number" min="1" value={editValues.durationMinutes} onChange={handleEditChange} style={styles.editInputSmall} />
                                        <span style={styles.unit}>min</span>
                                        <input name="price" type="number" min="0" step="0.01" value={editValues.price} onChange={handleEditChange} style={styles.editInputSmall} />
                                        <span style={styles.unit}>RSD</span>
                                    </div>
                                    <div style={styles.actions}>
                                        <button onClick={() => saveEdit(s.id)} style={styles.saveSmallBtn}>Sačuvaj</button>
                                        <button onClick={cancelEdit} style={styles.cancelBtn}>Otkaži</button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div style={styles.info}>
                                        <div style={styles.name}>{s.name}</div>
                                        <div style={styles.subtext}>
                                            {s.durationMinutes} min{s.price != null ? ` · ${s.price} RSD` : ''}
                                        </div>
                                    </div>
                                    <div style={styles.actions}>
                                        <button onClick={() => startEdit(s)} style={styles.editBtn}>Izmeni</button>
                                        <button onClick={() => handleDelete(s.id)} style={styles.deleteBtn}>Obriši</button>
                                    </div>
                                </>
                            )}
                        </div>
                    ))
                ) : (
                    <div style={{ textAlign: 'center', padding: '30px', color: '#888' }}>
                        Nema definisanih tipova tretmana.
                    </div>
                )}
            </div>
        </div>
    );
};

const styles = {
    container: {
        maxWidth: '800px',
        margin: '0 auto',
        padding: '15px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
    title: { margin: 0, fontSize: '24px', color: '#1f2937' },
    addBtn: { padding: '10px 15px', backgroundColor: '#27ae60', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' },
    form: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '10px',
        padding: '15px',
        backgroundColor: '#f1f3f5',
        borderRadius: '10px',
        marginBottom: '20px'
    },
    input: { padding: '12px', border: '1px solid #ccc', borderRadius: '6px' },
    saveBtn: { gridColumn: 'span 2', padding: '12px', backgroundColor: '#2980b9', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold' },
    listWrapper: { backgroundColor: 'white', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '15px',
        borderBottom: '1px solid #eee',
        gap: '10px',
        flexWrap: 'wrap'
    },
    info: { display: 'flex', flexDirection: 'column' },
    name: { fontSize: '17px', fontWeight: '600', color: '#1f2937', marginBottom: '4px' },
    subtext: { fontSize: '13px', color: '#7f8c8d' },
    actions: { display: 'flex', gap: '8px' },
    editBtn: { padding: '8px 12px', backgroundColor: '#f59e0b', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
    deleteBtn: { padding: '8px 12px', backgroundColor: '#e74c3c', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
    saveSmallBtn: { padding: '8px 12px', backgroundColor: '#10b981', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
    cancelBtn: { padding: '8px 12px', backgroundColor: '#94a3b8', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
    editFields: { display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' },
    editInput: { padding: '8px', border: '1px solid #ccc', borderRadius: '6px', width: '160px' },
    editInputSmall: { padding: '8px', border: '1px solid #ccc', borderRadius: '6px', width: '80px' },
    unit: { fontSize: '13px', color: '#7f8c8d' }
};

export default ServicesPanel;
